import React, { Component } from "react";
import PropTypes from 'prop-types';
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
// activities imports 
import DragAndDrop from "./CustomActivities/DragAndDrop.js";
import FillSentence from "./CustomActivities/FillSentence.js";
import MultipleChoice from "./CustomActivities/MultipleChoice.js";
import AudioChoice from "./CustomActivities/AudioChoice.js";

const styles = theme => ({
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    },
    hidden : {
        display: 'none'
    }
});

class CadastrarAtividades extends Component {
    constructor(props) {
        super(props);
        this.state = {type: ''};

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>Cadastrar Atividade</h4>
                                <p className={classes.cardCategoryWhite}>Complete as informações para o cadastro</p>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <CustomSelect
                                        labelText="Tipo de Atividade" 
                                        id="name"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            type: "number",
                                            name: "type",
                                            value:this.state.type,
                                            onChange:this.handleChange
                                        }}
                                        selectItems={[
                                            {key: '10', value: 10, label: 'Multipla Escolha'},
                                            {key: '20', value: 20, label: 'Completar Frase'},
                                            // {key: '30', value: 30, label: 'Arrasta e Solta'},
                                            {key: '40', value: 40, label: 'Questão com Áudio'},
                                        ]}
                                        />
                                    </GridItem>
                                </GridContainer>
                                {(this.state.type === 10) ?
                                    <MultipleChoice unity={this.props.units} onClose={this.props.onClose}/> : (this.state.type === 20) ? 
                                    <FillSentence unity={this.props.units} onClose={this.props.onClose}/> : (this.state.type === 30) ? 
                                    <DragAndDrop unity={this.props.units} onClose={this.props.onClose}/> : (this.state.type === 40) ?
                                    <AudioChoice unity={this.props.units} onClose={this.props.onClose}/> : null
                                }
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    };
}

CadastrarAtividades.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styles)(CadastrarAtividades);